'use client';

import { forwardRef } from 'react';
import MuiCheckbox, { type CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

export interface CheckboxProps extends MuiCheckboxProps {
  label?: string;
}

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(({ label, ...props }, ref) => {
  if (label) {
    return <FormControlLabel control={<MuiCheckbox ref={ref} {...props} />} label={label} />;
  }

  return <MuiCheckbox ref={ref} {...props} />;
});

Checkbox.displayName = 'Checkbox';
